import React, { useEffect } from 'react';
import { RouterProvider } from "react-router-dom";
import { routers } from './routers/routers';
import { MyContextProvider } from './context/MyContext';

import Layoute from './components/Layoute';
import './App.css';

function App() {
  
  // useEffect(() => {
  //   const html = document.getElementsByTagName('html')
  //   // localStorage.setItem('theme', 'dark')
  //   if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
  //     document.documentElement.classList.add('dark')
  //   } else {
  //     document.documentElement.classList.remove('dark')
  //   }
  //   localStorage.removeItem('theme')


  // }, [])
  
  // useEffect(() => {
  //   const themeBg = document.getElementById('theme-bg')
  //   const html = document.getElementsByTagName('html')
  //   console.log(html)
  //   if (html.length) {
  //     themeBg.classList.add('dark-bg')
  //     themeBg.classList.remove('light-bg')
  //   } else {
  //     themeBg.classList.remove('dark-bg')
  //     themeBg.classList.add('light-bg')
  //   }
  // }, [])

  return (
    <MyContextProvider>
      <RouterProvider router={routers} />
    </MyContextProvider>
  )
}

export default App;
